module.exports = require('./dist/codesplit/universal');
